import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1100px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            为什么选择我们
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-[500px] mx-auto">
            四大核心优势，打造极致观影体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {featuresData.map((item) => (
            <div
              key={item.id}
              className="group p-6 md:p-7 bg-background-100 rounded-lg border border-background-200/60 hover:border-primary-200/50 transition-all"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="mt-5 text-base md:text-lg font-semibold text-foreground-900">
                {item.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}